<div class="certificates-page">
  <header class="cert-topbar">
    <div class="cert-topbar-copy">
      <h1 class="cert-page-title">Certificates</h1>
      <nav class="cert-category-nav" aria-label="Certificate category">
        <button
          type="button"
          class="cert-category-card"
          *ngFor="let cat of certificateCategories"
          [class.is-active]="activeTab === cat.id"
          [attr.data-tone]="cat.id"
          (click)="setCertificateCategory(cat.id)"
        >
          <i class="pi" [ngClass]="cat.icon" aria-hidden="true"></i>
          <span>{{ cat.label }}</span>
        </button>
      </nav>
    </div>

    <div class="cert-topbar-actions">
      <div class="cert-patient-pill" *ngIf="selectedPatientLabel">
        <span class="cert-patient-avatar" aria-hidden="true">
          <i class="pi pi-user"></i>
        </span>
        <div class="cert-patient-copy">
          <strong>{{ selectedPatientLabel }}</strong>
          <small *ngIf="selectedPatientMeta">{{ selectedPatientMeta }}</small>
        </div>
        <button
          type="button"
          class="cert-patient-clear"
          (click)="clearSelectedPatient()"
          title="Clear patient"
          aria-label="Clear patient"
        >
          <i class="pi pi-times" aria-hidden="true"></i>
        </button>
      </div>

      <button type="button" class="cert-generate-btn" (click)="generateActivePdf()">
        <i class="pi pi-file-pdf" aria-hidden="true"></i>
        Generate PDF
      </button>
    </div>
  </header>

  <div class="certificates-layout">
    <section class="certificates-composer" aria-label="Certificate editor">
      <!-- MEDICAL -->
      <form
        [formGroup]="medicalForm"
        class="certificate-form cert-panel"
        [class.is-active]="activeTab === 'medical'"
        [attr.aria-hidden]="activeTab !== 'medical'"
      >
        <div class="cert-step cert-step--patient"><div class="cert-step-body"><div class="cert-step-head"><span class="cert-step-icon" aria-hidden="true"><i class="pi pi-user"></i></span><div class="cert-step-copy"><h2>Patient</h2><p>Search by name, number, or contact</p></div></div>
            <div class="cert-field">
              <div class="cert-control">
                <i class="pi pi-search cert-control-icon" aria-hidden="true"></i>
                <p-autoComplete
                  inputId="medical-patient"
                  [delay]="300"
                  [(ngModel)]="selectedPatient"
                  [suggestions]="patientsList"
                  (completeMethod)="searchPatients($event)"
                  [ngModelOptions]="{ standalone: true }"
                  (onSelect)="onPatientSelect($event)"
                  field="search_label"
                  placeholder="Search patient by name, number, or phone"
                  [forceSelection]="true"
                  [minLength]="2"
                  emptyMessage="No patients found"
                  styleClass="cert-autocomplete"
                  panelStyleClass="rx-patient-search-panel"
                  appendTo="body"
                  class="w-100"
                >
                  <ng-template let-patient pTemplate="item">
                    <div
                      class="rx-search-result"
                      [class.rx-search-result--free]="patient.is_free"
                    >
                      <span class="rx-search-result__avatar" aria-hidden="true">
                        {{ getPatientInitials(patient.name || patient.full_name) }}
                      </span>
                      <div class="rx-search-result__main">
                        <div class="rx-search-result__name-row">
                          <span class="rx-search-result__name">{{ patient.name || patient.full_name }}</span>
                          <span class="rx-search-result__badge" *ngIf="patient.is_free">Free visit</span>
                        </div>
                        <div
                          class="rx-search-result__details"
                          *ngIf="patient.patient_number || patient.contact_number"
                        >
                          <span class="rx-search-result__detail" *ngIf="patient.patient_number">
                            <i class="pi pi-id-card" aria-hidden="true"></i>
                            {{ patient.patient_number }}
                          </span>
                          <span class="rx-search-result__detail" *ngIf="patient.contact_number">
                            <i class="pi pi-phone" aria-hidden="true"></i>
                            {{ patient.contact_number }}
                          </span>
                        </div>
                      </div>
                      <i class="pi pi-chevron-right rx-search-result__arrow" aria-hidden="true"></i>
                    </div>
                  </ng-template>
                </p-autoComplete>
              </div>
            </div>
          </div>
        </div>

        <div class="cert-step cert-step--details"><div class="cert-step-body"><div class="cert-step-head"><span class="cert-step-icon" aria-hidden="true"><i class="pi pi-sliders-h"></i></span><div class="cert-step-copy"><h2>Details</h2><p>Type, date, and remarks</p></div></div>
            <div class="cert-grid cert-grid--2">
              <div class="cert-field">
                <label class="cert-label" for="medical-type">Certificate type</label>
                <p-dropdown
                  inputId="medical-type"
                  [options]="medicalTypes"
                  optionLabel="label"
                  optionValue="value"
                  formControlName="certificateType"
                  placeholder="Select certificate"
                  (onChange)="onTypeChange('medical')"
                  styleClass="cert-dropdown"
                  appendTo="body"
                ></p-dropdown>
              </div>
              <div class="cert-field">
                <label class="cert-label" for="medical-date">Date of examination</label>
                <p-calendar
                  inputId="medical-date"
                  formControlName="date"
                  dateFormat="dd-mm-yy"
                  [showIcon]="true"
                  styleClass="cert-calendar"
                  inputStyleClass="cert-calendar-input"
                  appendTo="body"
                ></p-calendar>
              </div>
            </div>
            <div class="cert-field cert-field--spaced">
              <label class="cert-label" for="medical-remarks">
                Remarks <span class="cert-optional">optional</span>
              </label>
              <textarea
                id="medical-remarks"
                rows="3"
                pInputTextarea
                formControlName="remarks"
                class="cert-textarea"
                placeholder="Optional notes on the certificate"
              ></textarea>
            </div>
          </div>
        </div>

        <div class="cert-step cert-step--wording"><div class="cert-step-body"><div class="cert-step-head"><span class="cert-step-icon" aria-hidden="true"><i class="pi pi-pencil"></i></span><div class="cert-step-copy"><h2>Wording</h2><p>Edit certificate text</p></div></div>
            <div class="cert-editor-wrap">
              <p-editor
                formControlName="certificateBody"
                (onTextChange)="onEditorTextChange($event, 'medical')"
                [style]="{ height: '180px' }"
              ></p-editor>
            </div>
          </div>
        </div>

        <div class="cert-mobile-cta">
          <button type="button" class="cert-generate-btn" (click)="generatePDFlocally('medical')">
            <i class="pi pi-file-pdf" aria-hidden="true"></i>
            Generate PDF
          </button>
        </div>
      </form>

      <!-- TRAVEL -->
      <form
        [formGroup]="travelForm"
        class="certificate-form cert-panel"
        [class.is-active]="activeTab === 'travel'"
        [attr.aria-hidden]="activeTab !== 'travel'"
      >
        <div class="cert-step cert-step--patient"><div class="cert-step-body"><div class="cert-step-head"><span class="cert-step-icon" aria-hidden="true"><i class="pi pi-user"></i></span><div class="cert-step-copy"><h2>Patient</h2><p>Search by name, number, or contact</p></div></div>
            <div class="cert-field">
              <div class="cert-control">
                <i class="pi pi-search cert-control-icon" aria-hidden="true"></i>
                <p-autoComplete
                  inputId="travel-patient"
                  [delay]="300"
                  [(ngModel)]="selectedPatient"
                  [suggestions]="patientsList"
                  (completeMethod)="searchPatients($event)"
                  [ngModelOptions]="{ standalone: true }"
                  (onSelect)="onPatientSelect($event)"
                  field="search_label"
                  placeholder="Search patient by name, number, or phone"
                  [forceSelection]="true"
                  [minLength]="2"
                  emptyMessage="No patients found"
                  styleClass="cert-autocomplete"
                  panelStyleClass="rx-patient-search-panel"
                  appendTo="body"
                  class="w-100"
                >
                  <ng-template let-patient pTemplate="item">
                    <div
                      class="rx-search-result"
                      [class.rx-search-result--free]="patient.is_free"
                    >
                      <span class="rx-search-result__avatar" aria-hidden="true">
                        {{ getPatientInitials(patient.name || patient.full_name) }}
                      </span>
                      <div class="rx-search-result__main">
                        <div class="rx-search-result__name-row">
                          <span class="rx-search-result__name">{{ patient.name || patient.full_name }}</span>
                          <span class="rx-search-result__badge" *ngIf="patient.is_free">Free visit</span>
                        </div>
                        <div
                          class="rx-search-result__details"
                          *ngIf="patient.patient_number || patient.contact_number"
                        >
                          <span class="rx-search-result__detail" *ngIf="patient.patient_number">
                            <i class="pi pi-id-card" aria-hidden="true"></i>
                            {{ patient.patient_number }}
                          </span>
                          <span class="rx-search-result__detail" *ngIf="patient.contact_number">
                            <i class="pi pi-phone" aria-hidden="true"></i>
                            {{ patient.contact_number }}
                          </span>
                        </div>
                      </div>
                      <i class="pi pi-chevron-right rx-search-result__arrow" aria-hidden="true"></i>
                    </div>
                  </ng-template>
                </p-autoComplete>
              </div>
            </div>
          </div>
        </div>

        <div class="cert-step cert-step--details"><div class="cert-step-body"><div class="cert-step-head"><span class="cert-step-icon" aria-hidden="true"><i class="pi pi-sliders-h"></i></span><div class="cert-step-copy"><h2>Details</h2><p>Type, date, and remarks</p></div></div>
            <div class="cert-grid cert-grid--2">
              <div class="cert-field">
                <label class="cert-label" for="travel-type">Certificate type</label>
                <p-dropdown
                  inputId="travel-type"
                  [options]="travelTypes"
                  optionLabel="label"
                  optionValue="value"
                  formControlName="certificateType"
                  placeholder="Select certificate"
                  (onChange)="onTypeChange('travel')"
                  styleClass="cert-dropdown"
                  appendTo="body"
                ></p-dropdown>
              </div>
              <div class="cert-field">
                <label class="cert-label" for="travel-date">Date of examination</label>
                <p-calendar
                  inputId="travel-date"
                  formControlName="date"
                  dateFormat="dd-mm-yy"
                  [showIcon]="true"
                  styleClass="cert-calendar"
                  inputStyleClass="cert-calendar-input"
                  appendTo="body"
                ></p-calendar>
              </div>
            </div>
            <div class="cert-field cert-field--spaced">
              <label class="cert-label" for="travel-remarks">
                Remarks <span class="cert-optional">optional</span>
              </label>
              <textarea
                id="travel-remarks"
                rows="3"
                pInputTextarea
                formControlName="remarks"
                class="cert-textarea"
                placeholder="Optional notes on the certificate"
              ></textarea>
            </div>
          </div>
        </div>

        <div class="cert-step cert-step--wording"><div class="cert-step-body"><div class="cert-step-head"><span class="cert-step-icon" aria-hidden="true"><i class="pi pi-pencil"></i></span><div class="cert-step-copy"><h2>Wording</h2><p>Edit certificate text</p></div></div>
            <div class="cert-editor-wrap">
              <p-editor
                formControlName="certificateBody"
                (onTextChange)="onEditorTextChange($event, 'travel')"
                [style]="{ height: '180px' }"
              ></p-editor>
            </div>
          </div>
        </div>

        <div class="cert-mobile-cta">
          <button type="button" class="cert-generate-btn" (click)="generatePDFlocally('travel')">
            <i class="pi pi-file-pdf" aria-hidden="true"></i>
            Generate PDF
          </button>
        </div>
      </form>

      <!-- EXPORT -->
      <form
        [formGroup]="exportForm"
        class="certificate-form cert-panel"
        [class.is-active]="activeTab === 'export'"
        [attr.aria-hidden]="activeTab !== 'export'"
      >
        <div class="cert-step cert-step--patient"><div class="cert-step-body"><div class="cert-step-head"><span class="cert-step-icon" aria-hidden="true"><i class="pi pi-user"></i></span><div class="cert-step-copy"><h2>Patient</h2><p>Search by name, number, or contact</p></div></div>
            <div class="cert-field">
              <div class="cert-control">
                <i class="pi pi-search cert-control-icon" aria-hidden="true"></i>
                <p-autoComplete
                  inputId="export-patient"
                  [delay]="300"
                  [(ngModel)]="selectedPatient"
                  [suggestions]="patientsList"
                  (completeMethod)="searchPatients($event)"
                  [ngModelOptions]="{ standalone: true }"
                  (onSelect)="onPatientSelect($event)"
                  field="search_label"
                  placeholder="Search patient by name, number, or phone"
                  [forceSelection]="true"
                  [minLength]="2"
                  emptyMessage="No patients found"
                  styleClass="cert-autocomplete"
                  panelStyleClass="rx-patient-search-panel"
                  appendTo="body"
                  class="w-100"
                >
                  <ng-template let-patient pTemplate="item">
                    <div
                      class="rx-search-result"
                      [class.rx-search-result--free]="patient.is_free"
                    >
                      <span class="rx-search-result__avatar" aria-hidden="true">
                        {{ getPatientInitials(patient.name || patient.full_name) }}
                      </span>
                      <div class="rx-search-result__main">
                        <div class="rx-search-result__name-row">
                          <span class="rx-search-result__name">{{ patient.name || patient.full_name }}</span>
                          <span class="rx-search-result__badge" *ngIf="patient.is_free">Free visit</span>
                        </div>
                        <div
                          class="rx-search-result__details"
                          *ngIf="patient.patient_number || patient.contact_number"
                        >
                          <span class="rx-search-result__detail" *ngIf="patient.patient_number">
                            <i class="pi pi-id-card" aria-hidden="true"></i>
                            {{ patient.patient_number }}
                          </span>
                          <span class="rx-search-result__detail" *ngIf="patient.contact_number">
                            <i class="pi pi-phone" aria-hidden="true"></i>
                            {{ patient.contact_number }}
                          </span>
                        </div>
                      </div>
                      <i class="pi pi-chevron-right rx-search-result__arrow" aria-hidden="true"></i>
                    </div>
                  </ng-template>
                </p-autoComplete>
              </div>
            </div>
          </div>
        </div>

        <div class="cert-step cert-step--details"><div class="cert-step-body"><div class="cert-step-head"><span class="cert-step-icon" aria-hidden="true"><i class="pi pi-sliders-h"></i></span><div class="cert-step-copy"><h2>Details</h2><p>Type, date, and remarks</p></div></div>
            <div class="cert-grid cert-grid--2">
              <div class="cert-field">
                <label class="cert-label" for="export-type">Certificate type</label>
                <p-dropdown
                  inputId="export-type"
                  [options]="exportTypes"
                  optionLabel="label"
                  optionValue="value"
                  formControlName="certificateType"
                  placeholder="Select certificate"
                  (onChange)="onTypeChange('export')"
                  styleClass="cert-dropdown"
                  appendTo="body"
                ></p-dropdown>
              </div>
              <div class="cert-field">
                <label class="cert-label" for="export-date">Date of examination</label>
                <p-calendar
                  inputId="export-date"
                  formControlName="date"
                  dateFormat="dd-mm-yy"
                  [showIcon]="true"
                  styleClass="cert-calendar"
                  inputStyleClass="cert-calendar-input"
                  appendTo="body"
                ></p-calendar>
              </div>
            </div>
            <div class="cert-field cert-field--spaced">
              <label class="cert-label" for="export-remarks">
                Remarks <span class="cert-optional">optional</span>
              </label>
              <textarea
                id="export-remarks"
                rows="3"
                pInputTextarea
                formControlName="remarks"
                class="cert-textarea"
                placeholder="Optional notes on the certificate"
              ></textarea>
            </div>
          </div>
        </div>

        <div class="cert-step cert-step--wording"><div class="cert-step-body"><div class="cert-step-head"><span class="cert-step-icon" aria-hidden="true"><i class="pi pi-pencil"></i></span><div class="cert-step-copy"><h2>Wording</h2><p>Edit certificate text</p></div></div>
            <div class="cert-editor-wrap">
              <p-editor
                formControlName="certificateBody"
                (onTextChange)="onEditorTextChange($event, 'export')"
                [style]="{ height: '160px' }"
              ></p-editor>
            </div>
          </div>
        </div>

        <div class="cert-step cert-step--medicines"><div class="cert-step-body"><div class="cert-step-head"><span class="cert-step-icon" aria-hidden="true"><i class="pi pi-box"></i></span><div class="cert-step-copy"><h2>Medicines</h2><p>Include on export certificate</p></div></div>

            <div class="export-medicines-panel">
              <div class="export-medicines-header">
                <div class="export-medicines-heading">
                  <span class="export-medicines-icon" aria-hidden="true">
                    <i class="pi pi-box"></i>
                  </span>
                  <div class="export-medicines-heading-text">
                    <h6 class="export-medicines-title">Prescribed medicines</h6>
                    <p class="export-medicines-subtitle">
                      {{ exportMedicinesForPreview.length }} medicine(s) for export
                    </p>
                  </div>
                </div>
                <button
                  type="button"
                  class="export-load-btn"
                  [disabled]="loadingExportMedicines"
                  (click)="loadExportMedicinesFromPrescription()"
                >
                  <i
                    class="pi"
                    [ngClass]="loadingExportMedicines ? 'pi-spin pi-spinner' : 'pi-download'"
                    aria-hidden="true"
                  ></i>
                  <span>Load from prescription</span>
                </button>
              </div>

              <div class="export-medicines-table-wrap">
                <table class="export-medicines-editor-table">
                  <thead>
                    <tr>
                      <th class="col-index">#</th>
                      <th class="col-medicine">Medicine</th>
                      <th class="col-potency">Potency</th>
                      <th class="col-container">Container</th>
                      <th class="col-actions" aria-label="Actions"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let row of exportMedicines; let i = index">
                      <td class="col-index">
                        <span class="export-medicine-index">{{ i + 1 }}</span>
                      </td>
                      <td class="col-medicine">
                        <p-autoComplete
                          [(ngModel)]="row.medicineName"
                          [ngModelOptions]="{ standalone: true }"
                          [suggestions]="filteredMedicineSuggestions"
                          (completeMethod)="searchMedicines($event)"
                          (onSelect)="onExportMedicineSelect(row, $event)"
                          (ngModelChange)="onExportMedicineChange()"
                          field="label"
                          placeholder="Search or type medicine"
                          [forceSelection]="false"
                          [dropdown]="true"
                          styleClass="export-medicine-input"
                          class="w-100"
                        ></p-autoComplete>
                      </td>
                      <td class="col-potency">
                        <input
                          type="text"
                          pInputText
                          class="w-100 export-text-input"
                          [(ngModel)]="row.potency"
                          [ngModelOptions]="{ standalone: true }"
                          (ngModelChange)="onExportMedicineChange()"
                          placeholder="30C"
                        />
                      </td>
                      <td class="col-container">
                        <div
                          class="export-container-wrap"
                          [class.has-custom-container]="row.container === 'other'"
                        >
                          <p-dropdown
                            [options]="containerOptions"
                            optionLabel="label"
                            optionValue="value"
                            [(ngModel)]="row.container"
                            [ngModelOptions]="{ standalone: true }"
                            placeholder="Select"
                            (onChange)="onExportMedicineChange()"
                            styleClass="export-container-dropdown"
                            class="w-100"
                            appendTo="body"
                          ></p-dropdown>
                          <input
                            *ngIf="row.container === 'other'"
                            type="text"
                            pInputText
                            class="w-100 export-text-input export-container-custom"
                            [(ngModel)]="row.customContainer"
                            [ngModelOptions]="{ standalone: true }"
                            (ngModelChange)="onExportMedicineChange()"
                            placeholder="Type container"
                          />
                        </div>
                      </td>
                      <td class="col-actions">
                        <button
                          type="button"
                          class="export-remove-btn"
                          aria-label="Remove medicine"
                          (click)="removeExportMedicineRow(i)"
                        >
                          <i class="pi pi-trash" aria-hidden="true"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <button type="button" class="export-add-row-btn" (click)="addExportMedicineRow()">
                <i class="pi pi-plus" aria-hidden="true"></i>
                <span>Add medicine</span>
              </button>
            </div>
          </div>
        </div>

        <div class="cert-mobile-cta">
          <button type="button" class="cert-generate-btn" (click)="generatePDFlocally('export')">
            <i class="pi pi-file-pdf" aria-hidden="true"></i>
            Generate PDF
          </button>
        </div>
      </form>
    </section>

    <aside class="certificates-preview-col" aria-label="Live certificate preview">
      <div class="preview-shell">
        <div class="preview-toolbar">
          <div class="preview-toolbar-copy">
            <span class="preview-live-dot" aria-hidden="true"></span>
            <div>
              <strong>Live preview</strong>
              <small>{{ activeCategoryMeta.label }} certificate</small>
            </div>
          </div>
          <span class="preview-toolbar-hint">Updates as you edit</span>
        </div>

        <div class="preview" *ngIf="previewData; else emptyPreview">
          <div class="certificate">
            <!-- HEADER -->
            <div class="certificate-header">
              <table width="100%" cellpadding="0" cellspacing="0">
                <tr>
                  <td width="35%" valign="top">
                    <div class="doctor-name">DR. SUBODH BHADE</div>
                    <div class="degree">B.H.M.S. MD (HMM), CAc, ND.</div>
                    <div class="designation">HOMOEOPATHIC CONSULTANT</div>
                    <div class="reg-no">Regd. No. 23009</div>
                  </td>
                  <td width="40%" valign="top" class="center-text">
                    <div class="address">
                      <b>Mukundnagar</b>
                      Tel: 020 - 24261180 / 24266888
                    </div>
                    <div class="address">
                      <b>Kothrud</b>
                      Tel: 020 - 25387888 / 25387886
                    </div>
                    <div class="address">
                      <b>Rasta Peth</b>
                      Tel: 020 - 26126844 / 26132613
                    </div>
                    <br />
                    <div class="contact">
                      E-mail : drsubodh&#64;hotmail.com<br />
                      Mobile : 98230 14580
                    </div>
                  </td>
                </tr>
              </table>
            </div>

            <hr class="header-divider" />

            <div class="info">
              <div><b>Patient Name:</b> {{ previewData.patientName }}</div>
              <div><b>Age / Sex:</b> {{ previewData.age }} / {{ previewData.gender }}</div>
              <div><b>Date of Examination:</b> {{ previewData.dateFormatted }}</div>
              <div><b>Doctor:</b> {{ previewData.doctorName }}</div>
            </div>

            <h3 class="type">
              {{ previewData.certificateType | uppercase }}
            </h3>

            <div class="body" [innerHTML]="previewData.certificateBody"></div>

            <div
              class="export-medicines-preview"
              *ngIf="previewData.exportMedicines?.length && activeTab === 'export'"
            >
              <div class="export-medicines-preview-card">
                <h4 class="export-medicines-preview-title">
                  <i class="pi pi-box" aria-hidden="true"></i>
                  Prescribed Medicines
                </h4>
                <table class="export-medicines-table">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Medicine</th>
                      <th>Potency</th>
                      <th>Container</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let row of previewData.exportMedicines; let i = index">
                      <td>{{ i + 1 }}</td>
                      <td>{{ row.medicineName || '-' }}</td>
                      <td>{{ row.potency || '-' }}</td>
                      <td>{{ getContainerLabel(row) }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div *ngIf="previewData.remarks" class="remarks">
              <b>Remarks:</b> {{ previewData.remarks }}
            </div>

            <div class="footer-sign">
              <div class="sign">Doctor Signature & Stamp</div>
            </div>
          </div>
        </div>

        <ng-template #emptyPreview>
          <div class="preview-empty">
            <i class="pi pi-file" aria-hidden="true"></i>
            <strong>Preview will appear here</strong>
            <p>Select a patient and certificate type to see the live document.</p>
          </div>
        </ng-template>
      </div>
    </aside>
  </div>
</div>
